import React, { useEffect, useCallback } from "react";
import { Drawer, Col, Row, Typography, Divider } from "antd";
import _ from "lodash";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getAtmedBookingHomeHealthcare } from "../../../../store/actions";

const { Paragraph, Text } = Typography;

const DescrtiptionItem = ({ title, value, showValue = !!value }) => (
  <Paragraph>
    {title && <Text className="lightFont">{`${title} `}</Text>}
    <div>
      {showValue ? (
        <Text className="darkFont">{value}</Text>
      ) : (
        <Text className="darkFont" type="secondary">
          Not Provided
        </Text>
      )}
    </div>
  </Paragraph>
);

const drawerTitle = (item) => {
  return (
    <Row>
      <Col span={16}>
        <DescrtiptionItem value={item.module} />
        <div className="fw500">#{item.bid}</div>
      </Col>
    </Row>
  );
};

const formatInfoTestLog = (result) => {
  if (!result || _.isEmpty(result)) return undefined;
  return { ...result };
};

const LabTestDescriptionModal = ({
  data = {},
  result,
  visible,
  onSubmit,
  onCancel,
  title,
  submitText,
  footer,
  ...props
}) => {
  const renderData = useCallback(() => {
    if (data.id) {
      props.getAtmedBookingHomeHealthcare.call(null, `id=${data.id}`);
    }
  }, [data, props.getAtmedBookingHomeHealthcare]);

  useEffect(() => {
    renderData();
  }, [renderData]);

  return (
    <Drawer
      title={drawerTitle(data)}
      placement="right"
      onClose={onCancel}
      visible={visible}
      onCancel={onCancel}
      // destroyOnClose
      width={500}
      {...props}
    >
      {result ? (
        <>
          <Row>
            <Col span={24} className="fw500 mb-10">
              <Text>BOOKING SUMMARY</Text>
            </Col>
            <Col span={12}>
              <DescrtiptionItem title="Booking ID" value={result.bid} />
            </Col>
            <Col span={12}>
              <DescrtiptionItem title="Booking Status" value={result.status} />
            </Col>
            <Col span={12}>
              <DescrtiptionItem
                title="Booking Date"
                value={result.booking_date}
              />
            </Col>
            <Col span={12}>
              <DescrtiptionItem title="Service" value={result.module} />
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col span={24}>
              <DescrtiptionItem
                title="Program Name"
                value={result.program_name}
              />
            </Col>
            <Col span={24}>
              <DescrtiptionItem
                title="Program Duration"
                value={result.program_duration}
              />
            </Col>
            <Col span={12}>
              <DescrtiptionItem
                title="Preferred Caregiver"
                value={result.caregiver_gender}
              />
            </Col>
            <Col span={12}>
              <DescrtiptionItem
                title="Total Sessions"
                value={result.total_sessions}
              />
            </Col>
            <Col span={12}>
              {/* <DescrtiptionItem title="" value={data.selected_dates} /> */}
              <Paragraph>
                <Text className="lightFont">Selected Dates</Text>
                <div>
                  {result.selected_dates.map((val) => (
                    <p style={{ marginBottom: "auto" }} className="darkFont">
                      {val}
                    </p>
                  ))}
                </div>
              </Paragraph>
            </Col>
            <Col span={12}>
              <DescrtiptionItem
                title="Preferred Time"
                value={result.preferred_time}
              />
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col span={24}>
              {/* <DescrtiptionItem title="Patient Name" value={result.payment_status} /> */}
              <Paragraph>
                <Text className="lightFont">Patient Name</Text>
                <div>
                  <Text className="darkFont">{result.patient_name}</Text>
                </div>
                <div>
                  <Text className="darkFont">
                    {result.patient_age}, {result.patient_gender}
                  </Text>
                </div>
              </Paragraph>
            </Col>
            <Col span={24}>
              <DescrtiptionItem title="Phone No" value={result.patient_phone} />
            </Col>
            <Col span={24}>
              <DescrtiptionItem
                title="Patient Address"
                value={result.address}
              />
            </Col>
            {/* <Col span={24}>
                  <DescrtiptionItem title="Ailment Information" value={result.ailment_desc} />
                </Col> */}
          </Row>
        </>
      ) : null}
    </Drawer>
  );
};

const mapStateToProps = ({ vendorEquipmenReducer = {} }) => ({
  result: formatInfoTestLog(
    vendorEquipmenReducer.singleAtmedBookingHomeHealthcare
  ),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAtmedBookingHomeHealthcare,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LabTestDescriptionModal);
